// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/components/ABSSwitch/index.less
// module id = 1033
// module chunks = 42